import { Star } from "lucide-react";
import { cn } from "../../utils/tailwindUtils";

// Mirrors the RATING_SCALE constant in emedhrmsapi/appraisal/constants.py.
// Kept inline (not API-fetched) because the scale is fixed across all cycles.
export const RATING_SCALE = [
    { value: 5, label: "Outstanding" },
    { value: 4, label: "Exceeds Expectations" },
    { value: 3, label: "Meets Expectations" },
    { value: 2, label: "Needs Improvement" },
    { value: 1, label: "Poor" },
];

const RatingPicker = ({ value, onChange, disabled = false, size = "md" }) => {
    const sortedAsc = [...RATING_SCALE].sort((a, b) => a.value - b.value);
    const dim = size === "sm" ? "w-5 h-5" : "w-6 h-6";

    return (
        <div className="flex flex-col gap-1">
            <div className="flex items-center gap-1">
                {sortedAsc.map((s) => {
                    const active = value !== null && value !== undefined && value >= s.value;
                    return (
                        <button
                            key={s.value}
                            type="button"
                            disabled={disabled}
                            onClick={() => !disabled && onChange?.(s.value)}
                            title={`${s.label} (${s.value})`}
                            className={cn(
                                "p-0.5 rounded transition-colors",
                                !disabled && "hover:scale-110",
                                disabled && "cursor-not-allowed opacity-70"
                            )}
                        >
                            <Star
                                className={cn(
                                    dim,
                                    active
                                        ? "fill-amber-400 text-amber-400"
                                        : "fill-transparent text-gray-300 dark:text-gray-600"
                                )}
                            />
                        </button>
                    );
                })}
                {value ? (
                    <span className="ml-2 text-xs font-medium text-gray-700 dark:text-gray-300">
                        {RATING_SCALE.find((s) => s.value === value)?.label}
                    </span>
                ) : (
                    <span className="ml-2 text-xs text-muted-foreground">Not rated</span>
                )}
            </div>
        </div>
    );
};

export default RatingPicker;
